// page-notes-web/src/components/Modals/FolderPicker.jsx
import { useState, useRef, useEffect } from 'react';
import { useFolders } from '../../contexts/FoldersContext';
import './FolderPicker.css';

export default function FolderPicker({ value, onChange, disabled = false }) {
  const { folders, loading } = useFolders();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedFolder = folders.find(f => f.id === value);

  const handleSelect = (folderId) => {
    onChange(folderId);
    setIsOpen(false);
  };

  return (
    <div className="folder-picker" ref={containerRef}>
      <button
        type="button"
        className={`picker-trigger ${isOpen ? 'open' : ''}`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
      >
        {selectedFolder ? (
          <>
            <span className="trigger-icon" style={{ color: selectedFolder.color }}>
              {selectedFolder.icon || '📁'}
            </span>
            <span className="trigger-text">{selectedFolder.name}</span>
          </>
        ) : (
          <>
            <span className="trigger-icon">📁</span>
            <span className="trigger-text placeholder">No folder</span>
          </>
        )}
        <span className="trigger-arrow">▾</span>
      </button>

      {isOpen && (
        <div className="picker-dropdown">
          <button
            type="button"
            className={`picker-option ${!value ? 'selected' : ''}`}
            onClick={() => handleSelect(null)}
          >
            <span className="option-icon">📁</span>
            <span className="option-text">No folder</span>
          </button>
          
          {loading ? (
            <div className="picker-loading">Loading folders...</div>
          ) : folders.length === 0 ? (
            <div className="picker-empty">No folders created yet</div>
          ) : (
            folders.map(folder => (
              <button
                key={folder.id}
                type="button"
                className={`picker-option ${value === folder.id ? 'selected' : ''}`}
                onClick={() => handleSelect(folder.id)}
              >
                <span className="option-icon" style={{ color: folder.color }}>
                  {folder.icon || '📁'}
                </span>
                <span className="option-text">{folder.name}</span>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}